import React from 'react'
import { waitlistReducer, initialWaitlistState } from '../../store/waitlist'
import { WaitlistService } from '../../services/waitlist/_waitlistService'
import { WaitlistContext, type WaitlistContextType } from './_context'

export const WaitlistProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [state, dispatch] = React.useReducer(waitlistReducer, initialWaitlistState)

  const waitlistService = React.useMemo(
    () => new WaitlistService(state, dispatch),
    [state, dispatch],
  )

  const contextValue = React.useMemo<WaitlistContextType>(
    () => waitlistService.getContextProps(),
    [waitlistService],
  )

  return (
    <WaitlistContext.Provider value={contextValue}>
      {children}
    </WaitlistContext.Provider>
  )
}
